import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler({ showDialog: false });

  private isHandlingError = false;
  private errorCount = 0;
  private readonly maxErrorCount = 10;

  handleError(error: any): void {
    if (this.isHandlingError || this.errorCount >= this.maxErrorCount) {
      if (this.errorCount >= this.maxErrorCount) {
        setTimeout(() => {
          this.errorCount = 0;
        }, 10000);
      }
      return;
    }

    const isStackOverflow =
      error?.message?.includes('Maximum call stack size exceeded') ||
      (error?.name === 'RangeError' && error?.message?.includes('stack'));

    this.isHandlingError = true;
    this.errorCount++;

    try {
      if (!isStackOverflow && this.errorCount < 3) {
        try {
          this.sentryHandler.handleError(error);
        } catch (sentryError) {}
      }
    } catch (handlerError) {
    } finally {
      this.isHandlingError = false;
    }
  }
}
